import { Action } from 'redux';

import { RootAdminUiState } from '../../state/RootAdminUIState';
import { SetRootAdminUiState } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetRootAdminUiStateAction extends Action {
  rootAdminUiState: RootAdminUiState;
}

export function setRootAdminUiState(rootAdminUiState: RootAdminUiState): SetRootAdminUiStateAction {
  return {
    type: SetRootAdminUiState,
    rootAdminUiState
  };
}

export const isSetRootAdminUiStateAction = isActionFactory<SetRootAdminUiStateAction>(SetRootAdminUiState);
